export function getFormData<T>(data: T) {
    const formData = new FormData();
    for (const k in data) {
        let prop = data[k];
        if (prop == null) continue;
        else if (Array.isArray(prop)) {
            prop.forEach(item => {
                formData.append(k, item);
            });
            continue;
        } else {
            formData.append(k as string, prop as string | Blob);
        }
    }
    return formData;
}

export type ValidationErrors<T> = {
    [P in keyof T]?: string;
};

export const validate = <T>(
    value: Partial<T>,
    ERROR_MESSAGES: { [P in keyof T]?: string },
    scrollToError: boolean = false
) => {
    const errors: { [P in keyof T]?: string } = {};
    for (const key in ERROR_MESSAGES) {
        const keyType = key as keyof T;
        if (!value[keyType]) errors[keyType] = ERROR_MESSAGES[keyType];
    }

    if (scrollToError && Object.keys(errors).length)
        document.getElementById(Object.keys(errors)[0])?.scrollIntoView({ behavior: "smooth" });

    return errors;
};

export const onChange = <T>(
    diff: Partial<T>,
    set: React.Dispatch<React.SetStateAction<Partial<T>>>,
    setErrors: React.Dispatch<React.SetStateAction<ValidationErrors<T>>>
) => {
    set(previousState => ({ ...previousState, ...diff }));

    setErrors(errors => {
        const filteredErrors = Object.fromEntries(
            Object.entries(errors).filter(([key]) => !(key in diff))
        ) as ValidationErrors<T>;
        return filteredErrors;
    });
};
